import React from "react";
import { StatsCard } from "../../../../../components/stats-card";
import styles from "../css/delivery-stats-grid.module.css";

export default function DeliveryStatsCardGrid({ scheduled = 0, pending = 0, assigned = 0, inTransit = 0 }) {
  return (
    <div className={styles.grid}>
      <StatsCard
        title="Scheduled Deliveries"
        value={scheduled}
        icon="truck"
        interactive={false}
        inlineIcon
      />
      <StatsCard
        title="Pending"
        value={pending}
        icon="hourglass"
        interactive={false}
        inlineIcon
      />
      <StatsCard
        title="Assigned"
        value={assigned}
        icon="user-plus"
        interactive={false}
        inlineIcon
      />
      <StatsCard
        title="In Transit"
        value={inTransit}
        icon="truck"
        interactive={false}
        inlineIcon
      />
    </div>
  );
}
